import {
  connectPerson,
  connectVariables,
  refreshLists,
} from './connections.query';
import { confirmInvites } from './use-run-connection-action';

import type { Card } from './tagged-people';

/** Sends what the card offers to each of its people, one at a time. An invite batch is confirmed once first. Sending
 * stops at the first refusal, which the send already told the user, because a limit would repeat for everyone else.
 * The lists are read again once, after the last send. Resolves to whether every send went through. */
export const sendToTaggedPeople = async ({
  kind,
  people,
}: Card): Promise<boolean> => {
  if (kind === 'invite') {
    const invites = people.map(({ person, entry }) => ({
      name: person.name,
      email: entry.email,
    }));
    if (!(await confirmInvites(invites))) return false;
  }
  let sentCount = 0;
  try {
    for (const { person, entry } of people) {
      await connectPerson(person, connectVariables(entry, 'composer_card'));
      sentCount += 1;
    }
    return true;
  } catch {
    return false;
  } finally {
    if (sentCount > 0) await refreshLists();
  }
};
